import ACTION_TYPE from 'components/../redux/actions/actionTypes';
import ApiHelper from 'utils/apiHelper';
import { API_URL } from 'utils/constants';
import { toast } from 'react-toastify';

export const getSettings =
    (isLoad = true) =>
    (dispatch) => {
        if (isLoad) {
            ApiHelper.get(API_URL.GENERAL_SETTINGS)
                .then((res) => {
                    dispatch({
                        type: ACTION_TYPE.LOAD_SETTINGS,
                        data: res.data
                    });
                })
                .catch((err) => {
                    if (err.response.status !== 401) {
                        dispatch({
                            type: ACTION_TYPE.LOAD_SETTINGS_FAILED,
                            data: err.response.message
                        });
                        toast.error('Failed to get the settings data');
                    }
                });
        } else {
            dispatch({
                type: ACTION_TYPE.INIT_SETTINGS
            });
        }
    };

export const updateSettings = (data) => (dispatch) => {
    dispatch({
        type: ACTION_TYPE.LOAD_SETTINGS,
        data
    });
};

export const putSettings =
    (settings, isToast = true) =>
    (dispatch) => {
        if (!settings.generalSettings.id) {
            return;
        }
        ApiHelper.put(`${API_URL.GENERAL_SETTINGS}${settings.generalSettings.id}/`, {
            show_rows: settings.generalSettings.showRows,
            checkin: settings.generalSettings.checkinInterval,
            show_unlicensed_for: settings.generalSettings.showUnlicensedFor,
            unlicensed_after: settings.generalSettings.unlicensedAfter,
            show_unlicensed_devices: settings.generalSettings.showUnlicensedDevices,
            keep_days: settings.generalSettings.dataRetention,
            equivalent_id: settings.generalSettings.equivalentId,
            avoidance_id: settings.generalSettings.avoidanceId,
            sequestered_id: settings.generalSettings.sequesteredId,
            energy_cost: settings.energyValues.energyCost,
            co2cost: settings.energyValues.co2Cost,
            green_power_percent: settings.energyValues.greenPowerPercent,
            selected_dashboards: settings.selectedDashboards,
            debuglevel_id: settings.levelSettings.debugLevelId,
            currency: settings.energyValues.currency,
            units: settings.energyValues.units
        })
            .then(() => {
                if (isToast) {
                    toast.success('Successfully Updated.');
                }
                dispatch({
                    type: ACTION_TYPE.LOAD_SETTINGS,
                    data: settings
                });
            })
            .catch(() => {
                if (isToast) {
                    toast.error('Failed to update the settings data.');
                }
            });
    };
